// removed by extract-text-webpack-plugin
module.exports = {"base-cta":"BaseCta__base-cta","baseCta":"BaseCta__base-cta","google-play-lg":"BaseCta__google-play-lg","googlePlayLg":"BaseCta__google-play-lg","google-play-sm":"BaseCta__google-play-sm","googlePlaySm":"BaseCta__google-play-sm","apple-app-store-lg":"BaseCta__apple-app-store-lg","appleAppStoreLg":"BaseCta__apple-app-store-lg","apple-app-store-sm":"BaseCta__apple-app-store-sm","appleAppStoreSm":"BaseCta__apple-app-store-sm"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/BaseCta/BaseCta.scss
// module id = 1525
// module chunks = 8